import { isNil } from 'lodash-es';
import { LandingCheckout } from '@dev/ee-api/ee-api-models'
import { CheckoutCreatorTemplate, CheckoutMetaData } from '@/store/checkoutCreator/types';

export const getStepsValidity = (isStep3Visible: boolean, template: CheckoutCreatorTemplate, checkoutObject: LandingCheckout, checkoutMetaDataObject?: CheckoutMetaData): Record<number, boolean> => {
    const isStep1Valid = !!checkoutObject?.Name && !!checkoutObject?.Currency && !!checkoutObject?.ProductPrice && !!checkoutObject?.DownloadUrl;
    const isStep2Valid = isStep1Valid && !!template.loadedJson;
    const isStep3Valid = isStep2Valid && (!isStep3Visible || !!checkoutObject?.ProductLanding?.LandingUrl);
    const isStep4Valid = isStep3Valid && !isNil(checkoutMetaDataObject?.data?.socialPreview);


    const step5IsContent = checkoutObject?.PostPurchaseTemplate?.Body?.Parts?.length > 0;
    const step5IsAudience = checkoutObject?.CheckoutAudience?.length > 0;
    const step5IsEmail = !!checkoutObject?.PostPurchaseTemplate?.FromEmail;
    const step5IsSubject = !!checkoutObject?.PostPurchaseTemplate?.Body?.Subject;
    const isStep5Valid = isStep1Valid && isStep2Valid && isStep3Valid && isStep4Valid && step5IsContent && step5IsAudience && step5IsEmail && step5IsSubject;

    return {
        1: isStep1Valid,
        2: isStep2Valid,
        3: isStep3Valid,
        4: isStep4Valid,
        5: isStep5Valid,
    };
};
